import { render, staticRenderFns } from "./CtaSection.vue?vue&type=template&id=1faa4f84&"
import script from "./CtaSection.vue?vue&type=script&lang=js&"
export * from "./CtaSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiBtn: require('/server/itg-custom/production/front/components/UiBtn.vue').default})
